// export default "/WebApi/"//测试、正式
// export default "http://www.test.zove/KyhyxyXG/WebApi/"
// export default "http://desktop-lk/SyauXG/WebAPI/"
export default "/KyhyxyXG/WebApi/"


// WEBPACK FOOTER //
// ./src/assets/js/baseUrl.js